var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 40L12.3 24.8L0 16H15.2L20 0L24.8 16H40L27.7 24.8L32.35 40L20 30.6L7.65 40Z",
    fill: "#192A3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaricon);
export default __webpack_public_path__ + "static/media/staricon.42b5f71399c167ef078f4f3345053c85.svg";
export { ForwardRef as ReactComponent };